import { useEffect } from 'react';

export const useResizeAndScroll = (
  isActive: boolean,
  onResize?: () => void,
  onScroll?: () => void,
  scrollTarget?: HTMLElement | Window
) => {
  useEffect(() => {
    if (!isActive) return;

    const handleResize = () => {
      onResize?.();
    };

    const handleScroll = () => {
      onScroll?.();
    };

    if (onResize) {
      window.addEventListener('resize', handleResize, { passive: true });
    }

    if (onScroll) {
      window.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    }

    return () => {
      if (onResize) {
        window.removeEventListener('resize', handleResize);
      }

      if (onScroll) {
        window.removeEventListener('scroll', handleScroll, { capture: true });
      }
    };
  }, [isActive, onResize, onScroll, scrollTarget]);
};
